export const environment = {
    firebaseConfig: {
    apiKey: "AIzaSyB9ouvTa0CxnOblwxGdSqXItNA6d86zhkU",
    authDomain: "developer-resources-2c411.firebaseapp.com",
    projectId: "developer-resources-2c411",
    storageBucket: "developer-resources-2c411.firebasestorage.app",
    messagingSenderId: "27205182354",
    appId: "1:27205182354:web:9e8e51058a074782cd574b",
    measurementId: "G-VNBVEKF562"
    }
};
